export const layoutsMisc = {
  confirm: {
    defaultTitle: "Sei sicuro?",
    confirm: "Conferma",
    cancel: "Annulla",
  },
  navPluginWeb: {
    title: "Crea sito web",
    stepOf: "{step} di 5",
  },
  saMenu: {
    title: "Azioni di sistema",
    subtitle: "Pannello delle automazioni",
    sectionComms: "COMUNICAZIONI",
    firstCheckin: "Invia al primo check-in",
  },
  systemActions: {
    checkin: "Check-in",
  },
  regionMessage: {
    text: "Contatta il team di supporto per configurare la connessione.",
    contactSupport: "Contatta il supporto",
  },
  selectionScanner: {
    title: "Scegli il tipo di documento da scansionare",
    idCard: "Carta d'identità",
    passport: "Passaporto",
  },
};
